



















































import { Component, Vue, Prop } from "vue-property-decorator";
import { ActionTypes } from "@/store/aciton-types";
import { RecipeItem } from "@/response";

@Component({
  props: {
    recipeItem: Object
  }
})
export default class RecipeItemComponent extends Vue {
  isAuthor(): boolean {
    try {
      if (
        (<any>this.$store.state.userStore).profile.username ===
        this.$props.recipeItem.author.username
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  isOwnPage(): boolean {
    if (this.$route.name === "my-recipes") {
      return true;
    }
    return false;
  }

  beforeMount() {}

  // ...mapGetters('userStore', {
  //   selfProfile: 'cartProducts',
  //   total: 'cartTotalPrice'
  // })
}
